import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  box: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    minHeight: '300px',
    zIndex: 2,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '24px 32px',
    padding: 0,
  },
  logo: {
    marginBottom: '30px',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
  },
  nutrien_logo: {
    width: '50%',
  },
});

export default useStyles;
